import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import _ from "lodash";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Body from "../components/Body";
import TopBar from "../components/TopBar";
import SubmitButton from "../components/SubmitButton";

import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";

import Landing from "../assets/images/landing.png";
import Corona from "../assets/images/corona.png";
import Dpy from "../assets/images/dpy.png";
import Icon1 from "../assets/images/illust1.png";
import Icon2 from "../assets/images/illust2.png";
import Collapse from "@material-ui/core/Collapse";

import { dispatch } from "../store";
const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal",
  color: "rgb(14 22 44)"
};

const styles = {
  adsText: {
    ...fontDefault,
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: "22px",
    marginBottom: "22px"
  },
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  expandButton: {
    marginLeft: "15px",
    marginRight: "15px",
    marginBottom: "15px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  expandText: {
    ...fontDefault,
    color: "#118DF5",
    fontSize: "14px"
  },
  expandIcon: {
    color: "#118DF5",
    fontSize: "20px"
  },
  topSection: {
    backgroundColor: "white",
    padding: "16px"
  },
  topText: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "24px"
  },
  flexCenter: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  topIcon: {
    width: "270px",
    marginBottom: "20px"
  },
  topDpyImage: {
    marginTop: "8px",
    width: "150px",
    marginBottom: "16px"
  },
  secondSection: {
    backgroundColor: "white",
    marginTop: "8px",
    padding: "16px"
  },
  secondHead: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "center"
  },
  secondText: {
    ...fontDefault,
    fontSize: "16px",
    textAlign: "center",
    marginTop: "16px",
    marginBottom: "24px"
  },
  secondIconContainer: {
    padding: "10px 0px",
    display: "flex",
    alignItems: "center"
  },
  secondIcon1: {
    width: "40px"
  },
  secondIcon2: {
    width: "40px"
  },
  secondIconText: {
    ...fontDefault,
    fontSize: "12px",
    color: "#878b96",
    marginLeft: "20px"
  },
  thirdHeadText: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold"
  },
  thirdHead: {
    display: "flex",
    justifyContent: "space-between"
  },
  thirdExpandIcon: {
    fontSize: "20px",
    color: "#333333"
  },
  thirdSeperate: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "16px"
  },
  number: {
    ...fontDefault,
    fontSize: "14px",
    color: "#878b96",
    marginRight: "8px"
  },
  sText: {
    ...fontDefault,
    fontSize: "14px",
    color: "#878b96"
  },
  lastSection: {
    ...fontDefault,
    fontSize: "12px",
    color: "rgb(135 139 150)",
    textAlign: "center",
    marginBottom: "24px"
  },
  lastSectionButton: {
    ...fontDefault,
    color: "rgb(20 123 209)",
    fontSize: "16px",
    textAlign: "center",
    marginTop: "8px",
    marginBottom: "24px"
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }
};

class App extends Component {
  state = {
    isExpand: false
  };

  goToNextPage = target => () => {
    dispatch({ type: "", buyFor: target });
    const mixpanel = _.get(window, "mixpanel", undefined);
    if (!!mixpanel) {
      mixpanel.track("Insurance Corona Enter", {});
    }
    const {
      history: { push }
    } = this.props;
    push("/packages");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  componentDidMount = () => {};

  render = () => {
    const { classes } = this.props;
    const { isExpand } = this.state;
    return (
      <Wrapper>
        <Body>
          <div className={classes.topSection}>
            <div className={classes.flexCenter}>
              <img
                src={Landing}
                className={classes.topIcon}
                alt="landing_icon"
              />
            </div>
            <Typography className={classes.topText}>
              ประกันภัยส่วนบุคคลคุ้มครองการติดเชื้อไวรัสโคโรนา Coronavirus
              (Covid-19)
            </Typography>
            <div className={classes.flexRow}>
              <SubmitButton
                onClick={this.goToNextPage("self")}
                margin={false}
                style={{ fontSize: "14px", width: "100%", marginRight: "4px" }}
              >
                ซื้อประกันภัยให้ตนเอง
              </SubmitButton>
              <SubmitButton
                onClick={this.goToNextPage("other")}
                margin={false}
                style={{ fontSize: "14px", width: "100%", marginLeft: "4px" }}
              >
                ซื้อประกันภัยให้ผู้อื่น
              </SubmitButton>
            </div>
            <Typography className={classes.adsText}>
              ค่าเบี้ยประกันเริ่มต้นเพียง{" "}
              <span style={{ color: "rgb(17 141 245)", fontSize: "20px" }}>
                150{" "}
              </span>
              <span style={{ color: "rgb(17 141 245)" }}>บาท</span>
            </Typography>
            <div className={classes.secondIconContainer}>
              <img src={Icon1} alt="icon1" className={classes.secondIcon1} />
              <Typography className={classes.secondIconText}>
                การเจ็บป่วยด้วยภาวะหรือโรคร้ายแรงที่มีสาเหตุมาจากการ
                ติดเชื้อไวรัสโคโรนา (Coronavirus (2019-nCoV))**
              </Typography>
            </div>
            <div className={classes.secondIconContainer}>
              <img src={Icon2} alt="icon2" className={classes.secondIcon2} />
              <Typography className={classes.secondIconText}>
                การรักษาพยาบาลจากการติดเชื้อไวรัสโคโรนา (Coronavirus
                (2019-nCoV))
              </Typography>
            </div>
          </div>
          <div className={classes.secondSection}>
            <div
              className={classes.thirdHead}
              button
              onClick={() => {
                this.setState({
                  isExpand: !!!isExpand
                });
              }}
            >
              <Typography className={classes.thirdHeadText}>
                เงื่อนไขการประกันภัยส่วนบุคคลคุ้มครองการติดเชื้อไวรัสโคโรนา
              </Typography>
              <Icon className={classes.thirdExpandIcon}>
                {!!isExpand === false ? "expand_more" : "expand_less"}
              </Icon>
            </div>
            <Collapse in={isExpand} timeout="auto" unmountOnExit>
              <br />
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>1)</Typography>
                <Typography className={classes.sText}>
                  ผู้เอาประกันภัยอายุระหว่าง 1 ปี - 99 ปี (ปี พ.ศ. ปัจจุบัน
                  ลบด้วยปี พ.ศ. เกิด) ณ วันที่ทำประกันภัย และ
                  ต้องมีสุขภาพร่างกายสมบูรณ์แข็งแรง ไม่พิการ
                  ไม่เป็นโรคเรื้อรังและผ่านการพิจารณารับประกันภัย
                </Typography>
              </div>
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>2)</Typography>
                <Typography className={classes.sText}>
                  กรมธรรม์ประกันภัยนี้ไม่คุ้มครองผู้ที่ติดเชื้อ หรือเป็น
                  ผู้ที่สงสัยว่าจะติดเชื้อ “โรคติดเชื้อไวรัสโคโรนา (Coronavirus
                  (2019-nCoV))” (รวมถึงภาวะ แทรกซ้อน)
                  ที่เป็นอยู่ก่อนการเอาประกันภัย และยังมิได้ รักษาให้หายขาด
                </Typography>
              </div>
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>3)</Typography>
                <Typography className={classes.sText}>
                  จำกัดการซื้อ 1 คน ต่อจำนวนเงินเอาประกันภัยไม่เกิน 1 ล้านบาท
                  และ/หรือค่ารักษาพยาบาลรวมกันไม่เกิน 1 แสนบาท
                </Typography>
              </div>
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>4)</Typography>
                <Typography className={classes.sText}>
                  **การเจ็บป่วยด้วยภาวะโคม่า หรือ ภาวะสมองตายและ
                  ระบบประสาทล้มเหลว หรือ
                  การเจ็บป่วยระยะสุดท้ายซึ่ง เป็นการเจ็บป่วยรุนแรงที่แพทย์ลงความเห็นว่าไม่มีวิธี
                  การรักษาให้หายได้ และ/หรือ เป็นสาเหตุทำให้เสียชีวิต
                  โดยมีสาเหตุหลักมาจากติดเชื้อไวรัสโคโรนา
                </Typography>
              </div>
              <div className={classes.thirdSeperate}>
                <Typography className={classes.number}>5)</Typography>
                <Typography className={classes.sText}>
                  ผลประโยชน์และความคุ้มครองเป็นไปตามข้อกำหนดและ
                  เงื่อนไขกรมธรรม์ประกันภัยคุ้มครองการติดเชื้อไวรัส โคโรนา
                  (Coronavirus (2019-nCoV))
                </Typography>
              </div>
            </Collapse>
          </div>
          <div className={classes.secondSection}>
            <Typography className={classes.lastSection}>
              ทรูมันนี่ วอลเล็ทเป็นเพียงช่องทางชำระเงิน
              และทำหน้าที่เป็นช่องทางในการเชื่อมต่อขอรับบริการทางอิเล็กทรอนิกส์
              กับบมจ.ทิพยประกันภัยเท่านั้น ทรูมันนี่
              วอลเล็ทไม่มีส่วนเกี่ยวข้องในการพิจารณา
              หรือรับผิดชอบในการรับประกันภัย
            </Typography>
          </div>
        </Body>
        <Header>
          <TopBar
            arrowLeft={() => {
              window.location.replace("ascendmoney://closewebview");
            }}
          >
            <Typography align="center" className={classes.textTopBar}>
              ประกันภัยไวรัสโคโรนา
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {}
  };
};

export default connect(mapStateToProps)(withStyles(styles)(App));
